<script lang="ts">
    import type {DocumentDetailReactivePageData, DocumentDetailStaticPageData} from '../../../record/kp-document-detail-page/types';
    import type {TabButton, TabId} from 'shared/ui-widgets/tabset/types';
    import type {RelatedRecordsTable} from '../../../record/kp-related-records-table/types';
    import {getPageContext} from 'shared/layouts/page-context';
    import {SUTOR_REPORTS_OPTIMISATION_SETTINGS} from 'src/features/sutor/sutor-constants';
    import KpRelatedRecordsTable from '../../../record/kp-related-records-table/KpRelatedRecordsTable.svelte';
    import SutorDocumentDetailTab from './tab-pages/SutorDocumentDetailTab.svelte';
    import SutorTabbedSubpagesContainer from '../../components/tabbed-subpages/SutorTabbedSubpagesContainer.svelte';
    import KpMediaViewerInline from '../../../media-viewer/KpMediaViewerInline.svelte';
    import SutorDocumentExportTab from './tab-pages/SutorDocumentExportTab.svelte';
    import SutorDocumentReportsOptimisationTab from 'src/features/sutor/pages/record-detail/tab-pages/reports-optimisation-tab/SutorDocumentReportsOptimisationTab.svelte';
    import ErpPageLayout from 'src/features/erp/components/ErpPageLayout.svelte';
    import SutorDocumentThreadTab from 'src/features/sutor/pages/record-detail/tab-pages/SutorDocumentThreadTab.svelte';

    export let relatedTables: RelatedRecordsTable[] = [];

    const pageContext = getPageContext<DocumentDetailStaticPageData, DocumentDetailReactivePageData>();
    const model = pageContext.staticData.model;

    const tabButtons: TabButton[] = [
        {
            id: 'tab-detail',
            label: 'Přehled',
            icon: 'info'
        }
    ];

    const tabs = {
        'tab-detail': {component: SutorDocumentDetailTab},
        'tab-files': {
            component: KpMediaViewerInline,
            props: {
                record: model.record
            }
        },
        'tab-export': {
            component: SutorDocumentExportTab,
            props: {
                record: model.record
            }
        },
        'tab-optimisation': {
            component: SutorDocumentReportsOptimisationTab,
            props: {
                record: model.record
            }
        },
        'tab-thread': {
            component: SutorDocumentThreadTab,
            props: {
                record: model.record
            }
        }
    };

    relatedTables.forEach((relatedTable) => {
        tabButtons.push({
            id: `tab-relatedtable-${relatedTable.tableId}`,
            label: relatedTable.title,
            icon: 'grid-alt',
            tabPageWithoutPadding: true,
            tabPageContainerClass: 'record-grid-tab-page'
        });
    });

    if (model.record.fond.id === SUTOR_REPORTS_OPTIMISATION_SETTINGS.projectFond) {
        tabButtons.push({
            id: 'tab-optimisation',
            label: 'Optimalizace nákladů',
            icon: 'money-check-edit',
            tabPageWithoutPadding: true
        });
    }

    if (model.record.fond.threadable) {
        tabButtons.push({
            id: 'tab-thread',
            label: 'Konverzace',
            icon: 'messages',
            tabPageWithoutPadding: true
        });
    }

    tabButtons.push({
        id: 'tab-files',
        label: 'Soubory',
        icon: 'file',
        tabPageWithoutPadding: true
    });

    tabButtons.push({
        id: 'tab-export',
        label: 'Tisk',
        icon: 'print'
    });

    function isTableTab(tabId: TabId): boolean {
        return tabId.includes('tab-relatedtable-');
    }
</script>

<ErpPageLayout pageClass="sutor-document-detail-tabbed-page" gap="0px" withoutContentPadding>
    <SutorTabbedSubpagesContainer {tabButtons} additionalClasses="document-detail-tabbed-subpages" let:activeTab>
        {#if isTableTab(activeTab)}
            {@const relatedTable = relatedTables.find((table) => `tab-relatedtable-${table.tableId}` === activeTab)}

            <KpRelatedRecordsTable record="{model.record}"
                                   fondId="{relatedTable.fondId}"
                                   fieldTypeId="{relatedTable.fieldTypeId}"
                                   hierarchyFieldTypeId="{relatedTable.hierarchyFieldTypeId}"/>
        {:else}
            <svelte:component this="{tabs[activeTab].component}" {...tabs[activeTab].props ?? {}}/>
        {/if}
    </SutorTabbedSubpagesContainer>
</ErpPageLayout>

<style lang="less">
    @import (reference) "styles/portaro.variables.less";
    @import (reference) "styles/portaro-erp.less";

    :global {
        .document-detail-tabbed-subpages {
            .kp-generic-tab-group .kp-generic-tab-list {
                padding: 0;
                border: none;
                background: none;
            }
        }
    }
</style>